export enum TagTypes {
  Both = 'both',
  Manual = 'manual',
  System = 'system'
}

export const Tags = {
  Async: 'async',
  Att: 'att',
  AttPrev: 'att-prev',
  Maintenance: 'maintenance',
  RxIncluded: 'rx-included',
  WeightLossPlan: 'weight-loss-plan',
  WeightLossPrevPlan: 'weight-loss-prev-plan'
} as const;

export enum TagCategories {
  ASYNC = 'async',
  IMPORTANT = 'important',
  MEDICAL_INCLUDED = 'medication-included',
  OTHER = 'other',
  PARTNER = 'partner',
  PLAN = 'plan',
  PREV_PLAN = 'prev-plan',
  SUB_PLAN = 'sub-plan'
}
